import { TypeContracts } from '../types';

export const isProduction = true;

export const showLogs = true;

export const network: string = isProduction
  ? 'https://api.trongrid.io'
  : 'https://api.shasta.trongrid.io';

export const contracts: TypeContracts = {
  type: isProduction ? 'mainnet' : 'testnet',
  contract: {
    ROUTER: {
      chain: {
        mainnet: {
          address: 'TK4KmfBCqsext7qJLoQTUrJ81UERAGCiGF',
          abi: [
            {
              inputs: [
                { name: '_factory', type: 'address' },
                { name: '_WTRX', type: 'address' },
              ],
              stateMutability: 'Nonpayable',
              type: 'Constructor',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'WTRX',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
                { name: 'liquidity', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'amountADesired', type: 'uint256' },
                { name: 'amountBDesired', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'addLiquidity',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
                { name: 'liquidity', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'amountTokenDesired', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'addLiquidityTRX',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'factory',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountIn', type: 'uint256' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'reserveIn', type: 'uint256' },
                { name: 'reserveOut', type: 'uint256' },
              ],
              name: 'getAmountIn',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountOut', type: 'uint256' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'reserveIn', type: 'uint256' },
                { name: 'reserveOut', type: 'uint256' },
              ],
              name: 'getAmountOut',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'path', type: 'address[]' },
              ],
              name: 'getAmountsIn',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'path', type: 'address[]' },
              ],
              name: 'getAmountsOut',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountB', type: 'uint256' }],
              inputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'reserveA', type: 'uint256' },
                { name: 'reserveB', type: 'uint256' },
              ],
              name: 'quote',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidity',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidityTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountTRX', type: 'uint256' }],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidityTRXSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityTRXWithPermit',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountTRX', type: 'uint256' }],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityTRXWithPermitSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityWithPermit',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTRXForTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTRXForTokensSupportingFeeOnTransferTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTRXSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTokensSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTRXForExactTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'amountInMax', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTokensForExactTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'amountInMax', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTokensForExactTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            { stateMutability: 'Payable', type: 'Receive' },
          ],
        },
        testnet: {
          address: 'TCyXd6VLz5KZaEWjqqqtd4BP96aBu4vX8V',
          // address: 'TC5WvjaW4gFWerTQxHL2osNPnPwfNK6QgZ',
          abi: [
            {
              inputs: [
                { name: '_factory', type: 'address' },
                { name: '_WTRX', type: 'address' },
              ],
              stateMutability: 'Nonpayable',
              type: 'Constructor',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'WTRX',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'factory',
              stateMutability: 'View',
              type: 'Function',
            },
            { stateMutability: 'Payable', type: 'Receive' },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
                { name: 'liquidity', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'amountADesired', type: 'uint256' },
                { name: 'amountBDesired', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'addLiquidity',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
                { name: 'liquidity', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'amountTokenDesired', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'addLiquidityTRX',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidity',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidityTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'amountB', type: 'uint256' },
              ],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountAMin', type: 'uint256' },
                { name: 'amountBMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityWithPermit',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [
                { name: 'amountToken', type: 'uint256' },
                { name: 'amountTRX', type: 'uint256' },
              ],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityTRXWithPermit',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountTRX', type: 'uint256' }],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'removeLiquidityTRXSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountTRX', type: 'uint256' }],
              inputs: [
                { name: 'token', type: 'address' },
                { name: 'liquidity', type: 'uint256' },
                { name: 'amountTokenMin', type: 'uint256' },
                { name: 'amountTRXMin', type: 'uint256' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
                { name: 'approveMax', type: 'bool' },
                { name: 'v', type: 'uint8' },
                { name: 'r', type: 'bytes32' },
                { name: 's', type: 'bytes32' },
              ],
              name: 'removeLiquidityTRXWithPermitSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'amountInMax', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTokensForExactTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTRXForTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'amountInMax', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTokensForExactTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTRX',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapTRXForExactTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTokensSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTRXForTokensSupportingFeeOnTransferTokens',
              stateMutability: 'Payable',
              type: 'Function',
            },
            {
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'amountOutMin', type: 'uint256' },
                { name: 'path', type: 'address[]' },
                { name: 'to', type: 'address' },
                { name: 'deadline', type: 'uint256' },
              ],
              name: 'swapExactTokensForTRXSupportingFeeOnTransferTokens',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountB', type: 'uint256' }],
              inputs: [
                { name: 'amountA', type: 'uint256' },
                { name: 'reserveA', type: 'uint256' },
                { name: 'reserveB', type: 'uint256' },
              ],
              name: 'quote',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountOut', type: 'uint256' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'reserveIn', type: 'uint256' },
                { name: 'reserveOut', type: 'uint256' },
              ],
              name: 'getAmountOut',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amountIn', type: 'uint256' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'reserveIn', type: 'uint256' },
                { name: 'reserveOut', type: 'uint256' },
              ],
              name: 'getAmountIn',
              stateMutability: 'Pure',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountIn', type: 'uint256' },
                { name: 'path', type: 'address[]' },
              ],
              name: 'getAmountsOut',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'amounts', type: 'uint256[]' }],
              inputs: [
                { name: 'amountOut', type: 'uint256' },
                { name: 'path', type: 'address[]' },
              ],
              name: 'getAmountsIn',
              stateMutability: 'View',
              type: 'Function',
            },
          ],
        },
      },
    },
    FACTORY: {
      chain: {
        mainnet: {
          address: 'TMhRH7pAikYBuK86kpFdrPboMaUfg7m2wW',
          abi: [
            {
              inputs: [{ name: '_feeToSetter', type: 'address' }],
              stateMutability: 'Nonpayable',
              type: 'Constructor',
            },
            {
              inputs: [
                { indexed: true, name: 'token0', type: 'address' },
                { indexed: true, name: 'token1', type: 'address' },
                { name: 'pair', type: 'address' },
                { type: 'uint256' },
              ],
              name: 'PairCreated',
              type: 'Event',
            },
            {
              outputs: [{ type: 'bytes32' }],
              name: 'INIT_CODE_PAIR_HASH',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'uint256' }],
              name: 'allPairs',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'feeTo',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'feeToSetter',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'address' }],
              name: 'getFeeAddress',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'address' }, { type: 'address' }],
              name: 'getPair',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'uint256' }],
              name: 'allPairsLength',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'pair', type: 'address' }],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
              ],
              name: 'createPair',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [{ name: '_feeTo', type: 'address' }],
              name: 'setFeeTo',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [
                { name: '_tokenAddress', type: 'address[]' },
                { name: '_devAddress', type: 'address[]' },
              ],
              name: 'setTokensDev',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [{ name: '_feeToSetter', type: 'address' }],
              name: 'setFeeToSetter',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
          ],
        },
        testnet: {
          address: 'TY3gBdRcd3uqpemqshVEbAy7TRWzoHMC2u',
          // address: 'TGKfSds9r7NRxtn5qaxWYRhr7iYTQg4xEp',
          abi: [
            {
              inputs: [
                { name: '_feeToSetter', type: 'address' },
                { name: '_eventEmitter', type: 'address' },
              ],
              stateMutability: 'Nonpayable',
              type: 'Constructor',
            },
            {
              inputs: [
                { indexed: true, name: 'token0', type: 'address' },
                { indexed: true, name: 'token1', type: 'address' },
                { name: 'pair', type: 'address' },
                { type: 'uint256' },
              ],
              name: 'PairCreated',
              type: 'Event',
            },
            {
              outputs: [{ type: 'bytes32' }],
              name: 'INIT_CODE_PAIR_HASH',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'uint256' }],
              name: 'allPairs',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'eventEmitter',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'feeTo',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              name: 'feeToSetter',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'address' }],
              name: 'getFeeAddress',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'address' }],
              inputs: [{ type: 'address' }, { type: 'address' }],
              name: 'getPair',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ type: 'uint256' }],
              name: 'allPairsLength',
              stateMutability: 'View',
              type: 'Function',
            },
            {
              outputs: [{ name: 'pair', type: 'address' }],
              inputs: [
                { name: 'tokenA', type: 'address' },
                { name: 'tokenB', type: 'address' },
              ],
              name: 'createPair',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [{ name: '_feeTo', type: 'address' }],
              name: 'setFeeTo',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [
                { name: '_tokenAddress', type: 'address[]' },
                { name: '_devAddress', type: 'address[]' },
              ],
              name: 'setTokensDev',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
            {
              inputs: [{ name: '_feeToSetter', type: 'address' }],
              name: 'setFeeToSetter',
              stateMutability: 'Nonpayable',
              type: 'Function',
            },
          ],
        },
      },
    },
    PAIR: {
      chain: {
        mainnet: {
          address: '',
          abi: [
            { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
                { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'Approval',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1', type: 'uint256' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
              ],
              name: 'Burn',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1', type: 'uint256' },
              ],
              name: 'Mint',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount0Out', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1Out', type: 'uint256' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
              ],
              name: 'Swap',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: false, internalType: 'uint112', name: 'reserve0', type: 'uint112' },
                { indexed: false, internalType: 'uint112', name: 'reserve1', type: 'uint112' },
              ],
              name: 'Sync',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'from', type: 'address' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'Transfer',
              type: 'event',
            },
            {
              inputs: [],
              name: 'DOMAIN_SEPARATOR',
              outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'MINIMUM_LIQUIDITY',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'PERMIT_TYPEHASH',
              outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: '', type: 'address' },
                { internalType: 'address', name: '', type: 'address' },
              ],
              name: 'allowance',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: 'spender', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'approve',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [{ internalType: 'address', name: '', type: 'address' }],
              name: 'balanceOf',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'burn',
              outputs: [
                { internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { internalType: 'uint256', name: 'amount1', type: 'uint256' },
              ],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'decimals',
              outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'factory',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'getReserves',
              outputs: [
                { internalType: 'uint112', name: '_reserve0', type: 'uint112' },
                { internalType: 'uint112', name: '_reserve1', type: 'uint112' },
                { internalType: 'uint32', name: '_blockTimestampLast', type: 'uint32' },
              ],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: '_token0', type: 'address' },
                { internalType: 'address', name: '_token1', type: 'address' },
              ],
              name: 'initialize',
              outputs: [],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'kLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'mint',
              outputs: [{ internalType: 'uint256', name: 'liquidity', type: 'uint256' }],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'name',
              outputs: [{ internalType: 'string', name: '', type: 'string' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [{ internalType: 'address', name: '', type: 'address' }],
              name: 'nonces',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: 'owner', type: 'address' },
                { internalType: 'address', name: 'spender', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
                { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                { internalType: 'uint8', name: 'v', type: 'uint8' },
                { internalType: 'bytes32', name: 'r', type: 'bytes32' },
                { internalType: 'bytes32', name: 's', type: 'bytes32' },
              ],
              name: 'permit',
              outputs: [],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'price0CumulativeLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'price1CumulativeLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'skim',
              outputs: [],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'uint256', name: 'amount0Out', type: 'uint256' },
                { internalType: 'uint256', name: 'amount1Out', type: 'uint256' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'bytes', name: 'data', type: 'bytes' },
              ],
              name: 'swap',
              outputs: [],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'symbol',
              outputs: [{ internalType: 'string', name: '', type: 'string' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'sync',
              outputs: [],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [],
              name: 'token0',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'token1',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [],
              name: 'totalSupply',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              stateMutability: 'view',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'transfer',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              inputs: [
                { internalType: 'address', name: 'from', type: 'address' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'transferFrom',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              stateMutability: 'nonpayable',
              type: 'function',
            },
          ],
        },
        testnet: {
          address: '',
          abi: [
            { inputs: [], payable: false, stateMutability: 'nonpayable', type: 'constructor' },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
                { indexed: true, internalType: 'address', name: 'spender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'Approval',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1', type: 'uint256' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
              ],
              name: 'Burn',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1', type: 'uint256' },
              ],
              name: 'Mint',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount0Out', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1Out', type: 'uint256' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
              ],
              name: 'Swap',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: false, internalType: 'uint112', name: 'reserve0', type: 'uint112' },
                { indexed: false, internalType: 'uint112', name: 'reserve1', type: 'uint112' },
              ],
              name: 'Sync',
              type: 'event',
            },
            {
              anonymous: false,
              inputs: [
                { indexed: true, internalType: 'address', name: 'from', type: 'address' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'Transfer',
              type: 'event',
            },
            {
              constant: true,
              inputs: [],
              name: 'DOMAIN_SEPARATOR',
              outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'MINIMUM_LIQUIDITY',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'PERMIT_TYPEHASH',
              outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [
                { internalType: 'address', name: '', type: 'address' },
                { internalType: 'address', name: '', type: 'address' },
              ],
              name: 'allowance',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'address', name: 'spender', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'approve',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [{ internalType: 'address', name: '', type: 'address' }],
              name: 'balanceOf',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'burn',
              outputs: [
                { internalType: 'uint256', name: 'amount0', type: 'uint256' },
                { internalType: 'uint256', name: 'amount1', type: 'uint256' },
              ],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'decimals',
              outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'factory',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'getReserves',
              outputs: [
                { internalType: 'uint112', name: '_reserve0', type: 'uint112' },
                { internalType: 'uint112', name: '_reserve1', type: 'uint112' },
                { internalType: 'uint32', name: '_blockTimestampLast', type: 'uint32' },
              ],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'address', name: '_token0', type: 'address' },
                { internalType: 'address', name: '_token1', type: 'address' },
              ],
              name: 'initialize',
              outputs: [],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'kLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'mint',
              outputs: [{ internalType: 'uint256', name: 'liquidity', type: 'uint256' }],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'name',
              outputs: [{ internalType: 'string', name: '', type: 'string' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [{ internalType: 'address', name: '', type: 'address' }],
              name: 'nonces',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'address', name: 'owner', type: 'address' },
                { internalType: 'address', name: 'spender', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
                { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                { internalType: 'uint8', name: 'v', type: 'uint8' },
                { internalType: 'bytes32', name: 'r', type: 'bytes32' },
                { internalType: 'bytes32', name: 's', type: 'bytes32' },
              ],
              name: 'permit',
              outputs: [],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'price0CumulativeLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'price1CumulativeLast',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [{ internalType: 'address', name: 'to', type: 'address' }],
              name: 'skim',
              outputs: [],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'uint256', name: 'amount0Out', type: 'uint256' },
                { internalType: 'uint256', name: 'amount1Out', type: 'uint256' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'bytes', name: 'data', type: 'bytes' },
              ],
              name: 'swap',
              outputs: [],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'symbol',
              outputs: [{ internalType: 'string', name: '', type: 'string' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [],
              name: 'sync',
              outputs: [],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'token0',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'token1',
              outputs: [{ internalType: 'address', name: '', type: 'address' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: true,
              inputs: [],
              name: 'totalSupply',
              outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
              payable: false,
              stateMutability: 'view',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'transfer',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
            {
              constant: false,
              inputs: [
                { internalType: 'address', name: 'from', type: 'address' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'value', type: 'uint256' },
              ],
              name: 'transferFrom',
              outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
              payable: false,
              stateMutability: 'nonpayable',
              type: 'function',
            },
          ],
        },
      },
    },
    WTRX: {
      chain: {
        mainnet: {
          address: 'TNUC9Qb1rRpS5CbWLmNMxXBjyFoydXjWFR',
          abi: [],
        },
        testnet: {
          address: 'TSsj3nsEWiYm81MGzCByjEtGVygh5sRBqd',
          abi: [],
        },
      },
    },
  },
};
